import { HttpContextToken } from '@angular/common/http';

export const LOGOUT_ON_401 = new HttpContextToken<boolean>(() => true);
